@if (activityElement) {
    <div class="activity-feed-instance"
         [ngClass]="{
            'activity-feed-child': !activityElement!.isTopLevelActivity,
            'activity-feed-instance-just-added': activityElement!.isNewActivity,
        }">
        <div class="activity-container"
             [ngClass]="{
                launch: launchPathObject && useCompact,
                compact: useCompact,
                unread: showAsUnread,
            }"
             (click)="redirectToPath()">
            @if (activityElement!.isTopLevelActivity) {
                <adapt-person-image [person]="activityElement!.relatedPerson"
                                    [imageSize]="imageSize"></adapt-person-image>
            }
            <div class="activity-content"
                 [ngClass]="{ compact: useCompact }">
                @if (activityInstance) {
                    <div class="activity-text"
                         [innerHTML]="activityInstance!.text"></div>
                    @if (activityInstance!.subtext && !hideSubtext) {
                        <div class="activity-subtext"
                             [innerHTML]="activityInstance!.subtext"></div>
                    }
                } @else {
                    <div>
                        {{ activityElement!.relatedPerson?.firstName || "Someone" }}
                        has made some changes.
                    </div>
                }
                <div class="activity-date"
                     [adaptTooltip]="useCompact ? undefined : (activityElement!.dateTime | adaptMoment: 'h:mm:ss a')">
                    @if (occurredLessThanAnHourAgo) {
                        {{ activityElement!.dateTime | timeAgo }}
                    } @else {
                        @if (showDate) {
                            {{ activityElement!.dateTime | adaptMoment: "DD MMM YYYY h:mm a" }}
                        } @else {
                            {{ activityElement!.dateTime | adaptMoment: "h:mm a" }}
                        }
                    }
                </div>
            </div>
            @if (launchPathObject && !useCompact) {
                <a class="activity-href"
                   [routerLink]="launchPathObject!.path"
                   [queryParams]="launchPathObject!.queryParams"
                   data-test="activity-launcher"
                   adaptTooltip="Click to open the source of this activity">
                    <i class="fal fa-external-link-alt"></i>
                </a>
            }
        </div>
    </div>
}
